import { Helmet } from "react-helmet";
import { Flex, Button, Text } from "@chakra-ui/react";
import withNavElements from "../../components/withNavElements";
import { useHistory } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";
import OrdersTable from "./OrdersTable";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { listOrders } from "../../actions/orderActions";
import OrderDetailModal from "../../components/modals/OrderDetailModal";
import { markOrderAsRead, archiveOrder } from "../../actions/orderActions";

const OrdersPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const ordersList = useSelector((state) => state.orderList);
    const { loading, orders } = ordersList;

    useEffect(() => {
        dispatch(listOrders());
    }, [dispatch]);

    const markAsReadHandler = (order) => {
        dispatch(markOrderAsRead(order._id));
    }

    const archiveHandler = (order) => {
        dispatch(archiveOrder(order._id));
    }

    return (
        <>
            <Flex
                flexDir="column"
                w="100%"
                minH="80vh"
                pt="120px"
                px={{ base: "40px", md: "40px" }}
            >
                <Helmet>
                    <title>Dashboard - Orders</title>
                </Helmet>
                <Flex flexDir="column" >
                    <SectionHeader
                        title="Pedidos"
                        description="Revisa los pedidos de tus clientes y actualiza su estado."
                    />
                    <OrdersTable 
                        data={orders}
                        loading={loading}
                        listOrders={listOrders}
                        markAsReadHandler={markAsReadHandler}
                        archiveHandler={archiveHandler}
                    />
                </Flex>
            </Flex>
            <OrderDetailModal />
        </>
    )
}

export default withNavElements(OrdersPage);